"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigDecimal =
/*#__PURE__*/
function () {
  function BigDecimal() {
    /**/

    _classCallCheck(this, BigDecimal);
  }

  _createClass(BigDecimal, [{
    key: "plus",
    value: function plus(other) {
      return this.add(other);
    }
  }, {
    key: "minus",
    value: function minus(other) {
      return this.sub(other);
    }
  }, {
    key: "times",
    value: function times(other) {
      return this.mul(other);
    }
  }, {
    key: "dividedBy",
    value: function dividedBy(other) {
      return this.div(other);
    }
  }, {
    key: "isInteger",
    value: function isInteger() {
      return false;
    }
  }, {
    key: "isNegative",
    value: function isNegative() {
      return this.sign() < 0;
    }
  }, {
    key: "isNeg",
    value: function isNeg() {
      return this.isNegative();
    }
  }, {
    key: "equals",
    value: function equals(other) {
      switch (typeof other) {
        case 'number':
          return this.eq(other);

        case 'object':
          if (other instanceof BigDecimal) {
            return this.eq(other);
          }

        default:
          return false;
      }
    }
  }, {
    key: "gt",
    value: function gt(other) {
      return this.greaterThan(other);
    }
  }, {
    key: "lt",
    value: function lt(other) {
      return this.lessThan(other);
    }
  }, {
    key: "lessThan",
    value: function lessThan(other) {
      if (typeof other === 'number') {
        other = BigDecimal.valueOf(other);
      }

      return other.isNaN() ? false : !this.greaterThan(other) && !this.equals(other);
    }
  }, {
    key: "lte",
    value: function lte(other) {
      return this.lessThanOrEqualTo(other);
    }
  }, {
    key: "lessThanOrEqualTo",
    value: function lessThanOrEqualTo(other) {
      return this.lessThan(other) || this.eq(other);
    }
  }, {
    key: "gte",
    value: function gte(other) {
      return this.greaterThanOrEqualTo(other);
    }
  }, {
    key: "greaterThanOrEqualTo",
    value: function greaterThanOrEqualTo(other) {
      return this.greaterThan(other) || this.eq(other);
    }
  }, {
    key: "comparedTo",
    value: function comparedTo(other) {
      if (typeof other === 'number') {
        other = BigDecimal.valueOf(other);
      }

      if (this.isNaN() || other.isNaN()) {
        return NaN;
      }

      if (this.eq(other)) {
        return 0;
      }

      return this.greaterThan(other) ? 1 : -1;
    }
  }, {
    key: "downscale",
    value: function downscale() {
      return this;
    }
  }, {
    key: "absoluteValue",
    value: function absoluteValue() {
      return this.abs();
    }
    /**
     * If rounding argument is omitted, returns nearest integer. If provided value is exactly in half between integers, returns greater one.
     * @param decimalPlaces
     * @param rounding
     * @throws error if decimalPlaces is outside limit of big decimal scale.
     */

  }, {
    key: "round",
    value: function round(decimalPlaces, rounding) {
      return this;
    }
    /**
     * Returns nearest integer that is less or equal to this value.
     */

  }, {
    key: "floor",
    value: function floor() {
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toString();
    }
  }, {
    key: "toFixed",
    value: function toFixed(decimalPlaces, rounding) {
      return this.toString();
    }
  }], [{
    key: "valueOf",
    value: function valueOf(n) {
      throw new Error('Must be replaced in index.ts');
    }
  }]);

  return BigDecimal;
}();

exports.BigDecimal = BigDecimal;
exports.maxScale = 6;
exports.maxPrecision = 26;
exports.maxInt = BigInt('999999999999999999999999999'); // BigInt(10) ** BigInt(maxPrecision + 1) - BigInt(1);

function assertIntValue(intVal) {
  if (intVal > exports.maxInt || -intVal > exports.maxInt) {
    throw new Error('Number base too big: ' + intVal);
  }
}

exports.assertIntValue = assertIntValue;
var BIG_TEN_POWERS_TABLE = [BigInt('1'), BigInt('10'), BigInt('100'), BigInt('1000'), BigInt('10000'), BigInt('100000'), BigInt('1000000'), BigInt('10000000'), BigInt('100000000'), BigInt('1000000000'), BigInt('10000000000'), BigInt('100000000000'), BigInt('1000000000000'), BigInt('10000000000000'), BigInt('100000000000000'), BigInt('1000000000000000'), BigInt('10000000000000000'), BigInt('100000000000000000'), BigInt('1000000000000000000'), BigInt('10000000000000000000'), BigInt('100000000000000000000')];

function bigMultiplyPowerTen(value, n) {
  if (n <= 0) {
    return value;
  }

  return value * bigPowerTen(n);
}

exports.bigMultiplyPowerTen = bigMultiplyPowerTen;

function bigPowerTen(n) {
  if (n < 0) {
    throw new Error('Bad exponent: ' + n);
  }

  var tableLength = BIG_TEN_POWERS_TABLE.length;

  if (n < tableLength) {
    return BIG_TEN_POWERS_TABLE[n];
  }

  if (n - tableLength >= tableLength) {
    throw new Error('Unimplemented exponent: ' + n);
  }

  return BIG_TEN_POWERS_TABLE[tableLength - 1] * bigPowerTen(n - (tableLength - 1)); //return value.multiply(bigTenToThe(n));
}

exports.bigPowerTen = bigPowerTen;